import React, { useState, useEffect } from 'react';
import './menu.css';
import { getFilteredMenu } from './menuPermissions';

export const gestionDeAlmacenMenu = [
    {
        title: 'Confronta',
        icono: 'Dashboard.svg',
        enlace: '#', 
        activo: 'importación/confronta',
        permiso: [1],
        hijos: [
            {
                title: 'Check In vuelos',
                icono: 'Dashboard.svg',
                enlace: 'CheckInFlights', // Corregido
                activo: 'importación/confronta/check_in_vuelos',
                permiso: [1],
            },
        ],
    },
    {
        title: 'Entradas',
        icono: 'Dashboard.svg',
        permiso: [2, 3, 4, 5, 6],
        enlace: '#', 
        activo: 'importación/entradas',
        hijos: [
            {
                title: 'Registro Vuelo',
                icono: 'Dashboard.svg',
                enlace: 'FlightRecords', // Corregido
                activo: 'importación/entradas/registro_vuelo',
                permiso: [6],
            },
            {
                title: 'Arribos',
                icono: 'Dashboard.svg',
                enlace: 'Arrivals', // Corregido
                activo: 'importación/entradas/arribos',
                permiso: [2],
            },
            {
                title: 'Alta Manifiesto',
                icono: 'Dashboard.svg',
                enlace: 'Manifiesto', // Corregido
                activo: 'importación/entradas/alta_manifiesto',
                permiso: [3],
            },
            {
                title: 'Alta Master',
                icono: 'Dashboard.svg',
                enlace: 'Master', // Corregido
                activo: 'importación/entradas/alta_master',
                permiso: [4],
            },
            {
                title: 'Alta Inventario',
                icono: 'Dashboard.svg',
                enlace: 'Inventario', // Corregido
                activo: 'importación/entradas/alta_inventario',
                permiso: [5],
            },
        ],
    },
    {
        title: 'Mostrador',
        icono: 'Dashboard.svg',
        enlace: '#', 
        activo: 'importación/mostrador',
        permiso: [7, 8, 9, 10],
        hijos: [
            {
                title: 'Pre-facturación',
                icono: 'Dashboard.svg',
                enlace: 'PreInvoices', // Corregido
                activo: 'importación/mostrador/pre-facturación',
                permiso: [7],
            },
            {
                title: 'Cobro en caja',
                icono: 'Dashboard.svg',
                enlace: 'CheckoutPayment',
                activo: 'importación/mostrador/cobro_en_caja',
                permiso: [8],
            },
            {
                title: 'Facturación múltiple',
                icono: 'Dashboard.svg',
                enlace: 'MultipleInvoices', // Corregido
                activo: 'importación/mostrador/facturación_múltiple',
                permiso: [9],
            },
            {
                title: 'Consulta facturas',
                icono: 'Dashboard.svg',
                enlace: '#', // Corregido
                activo: 'importación/mostrador/facturas',
                permiso: [10],
            },
        ],
    },
    {
        title: 'Supervisión Facturación',
        icono: 'Dashboard.svg',
        enlace: '#', 
        activo: 'importación/supervisión_facturación',
        permiso: [11, 12, 13, 14, 15, 16, 17, 18, 19],
        hijos: [
            {
                title: 'Dashboard cajas',
                icono: 'Dashboard.svg',
                enlace: '#', // Corregido
                activo: 'importación/supervisión_facturación/dashboard_cajas',
                permiso: [11],
            },
            {
                title: 'Dashboard previos',
                icono: 'Dashboard.svg',
                enlace: '#', // Corregido
                activo: 'importación/supervisión_facturación/previos',
                permiso: [12],
            },
            {
                title: 'Dashboard disponibilidad de documentos',
                icono: 'Dashboard.svg',
                enlace: 'DocumentAvail', // Corregido
                activo: 'importación/supervisión_facturación/disp_de_docs',
                permiso: [13],
            },
            {
                title: 'Dashboard facturas sin cobrar',
                icono: 'Dashboard.svg',
                enlace: '#', // Corregido
                activo: 'importación/supervisión_facturación/facturas_sin_cobrar',
                permiso: [14],
            },
            {
                title: 'Alta desco',
                icono: 'Dashboard.svg',
                enlace: 'AltaDesco', // Corregido
                activo: 'importación/supervisión_facturación/alta_desco',
                permiso: [15],
            },
            {
                title: 'Facturación administrativa',
                icono: 'Dashboard.svg',
                enlace: 'FactAdminImpo',
                activo: 'importación/supervisión_facturación/facturación_administrativa',
                permiso: [16],
            },
            {
                title: 'Batch Facturación',
                icono: 'Dashboard.svg',
                enlace: 'BatchBilling',
                activo: 'importación/supervisión_facturación/batch_facturación',
                permiso: [17],
            },
            {
                title: 'Batch Cancelación',
                icono: 'Dashboard.svg',
                enlace: '#', // Corregido
                activo: 'importación/supervisión_facturación/batch_cancelación',
                permiso: [18],
            },
            {
                title: 'Cancelación 02-03',
                icono: 'Dashboard.svg',
                enlace: '#', // Corregido
                activo: 'importación/supervisión_facturación/cancelación_02_03',
                permiso: [19],
            },
        ],
    },
    {
        title: 'Previos',
        icono: 'Dashboard.svg',
        enlace: 'Previous', // Corregido
        activo: 'importación/previos',
        permiso: [20],
        hijos: [],
    },
    {
        title: 'Locaciones',
        icono: 'Dashboard.svg',
        enlace: 'Locations', // Corregido
        activo: 'importación/locaciones',
        permiso: [21],
        hijos: [],
    },
    {
        title: 'Salidas',
        icono: 'Dashboard.svg',
        enlace: 'ImpoDepartures',
        activo: 'importación/salidas',
        permiso: [22],
        hijos: [],
    },
    {
        title: 'Reingresos',
        icono: 'Dashboard.svg',
        enlace: 'Reentries',
        activo: 'importación/reingresos',
        permiso: [23],
        hijos: [],
    },
    {
        title: 'Incidencias',
        icono: 'Dashboard.svg',
        enlace: '#', 
        activo: 'importación/incidencias',
        permiso: [24, 25, 26],
        hijos: [
            {
                title: 'Incidencias operativas',
                icono: 'Dashboard.svg',
                enlace: 'Incidents', // Corregido
                activo: 'importación/incidencias/incidencias_operativas',
                permiso: [24],
            },
            {
                title: 'Irregularidades SAT',
                icono: 'Dashboard.svg',
                enlace: 'IrregularidadesSat', // Corregido
                activo: 'importación/incidencias/irregularidades_SAT',
                permiso: [25],
            },
            {
                title: 'UPD M/H',
                icono: 'Dashboard.svg',
                enlace: 'Upd', // Corregido
                activo: 'importación/incidencias/upd_m_h',
                permiso: [26],
            },
        ],
    },
    {
        title: 'Puntos Tácticos',
        icono: 'Dashboard.svg',
        enlace: '#', 
        activo: 'importación/puntos_tácticos',
        permiso: [27, 28],
        hijos: [
            {
                title: 'Agregar registro',
                icono: 'Dashboard.svg',
                enlace: 'TacticalsCreate',
                activo: 'importación/puntos_tácticos/agregar_registro',
                permiso: [27],
            },
            {
                title: 'Consulta',
                icono: 'Dashboard.svg',
                enlace: 'Consultation', // Corregido
                activo: 'importación/puntos_tácticos/consulta',
                permiso: [28],
            },
        ],
    },
    {
        title: 'Kardex',
        icono: 'Dashboard.svg',
        enlace: 'KardexImpo', // Corregido
        activo: 'importación/kardex',
        permiso: [28],
        hijos: [],
    },
    {
        title: 'Reportes Importación',
        icono: 'Dashboard.svg',
        enlace: '#', 
        activo: 'importación/reportes_importación',
        permiso: [30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
        hijos: [
            {
                title: 'Check in vuelos',
                icono: 'Dashboard.svg',
                enlace: '#', // Corregido
                activo: 'importación/reportes_importación/check_in_vuelos',
                permiso: [30],
            },
            {
                title: 'Inventario Importación',
                icono: 'Dashboard.svg',
                enlace: 'RepImpInventario', // Corregido
                activo: 'importación/reportes_importación/inventario_importación',
                permiso: [31],
            },
            {
                title: 'Confronta',
                icono: 'Dashboard.svg',
                enlace: '#',
                activo: 'importación/reportes_importación/confronta',
                permiso: [32, 33, 34, 35, 36],
                hijos: [
                    {
                        title: 'Entradas Importación',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteImpoConfronta', // Corregido
                        activo: 'importación/reportes_importación/confronta/entradas_importación',
                        permiso: [32],
                    },
                    {
                        title: 'Importación MEX',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteImportacionMex', // Corregido
                        activo: 'importación/reportes_importación/confronta/importación_mex',
                        permiso: [33],
                    },
                    {
                        title: 'Vuelos Registrados',
                        icono: 'Dashboard.svg',
                        enlace: 'FlightRecordsReports', // Corregido
                        activo: 'importación/reportes_importación/confronta/vuelos_registrados',
                        permiso: [34],
                    },
                    {
                        title: 'Guías en vuelo',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteGuiasEnVuelo', // Corregido
                        activo: 'importación/reportes_importación/confronta/guías_en_vuelo',
                        permiso: [35],
                    },
                    {
                        title: 'Aerovías y otros',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteCliente0Impo', // Corregido
                        activo: 'importación/reportes_importación/confronta/aerovías_y_otros',
                        permiso: [36],
                    },
                ],
            },
            {
                title: 'Captura UPD',
                icono: 'Dashboard.svg',
                enlace: '#',
                activo: 'importación/reportes_importación/captura',
                permiso: [37, 38, 39],
                hijos: [
                    {
                        title: 'UPD Detalles',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteUPDDetalles', // Corregido
                        activo: 'importación/reportes_importación/captura_upd/upd_detalles',
                        permiso: [37],
                    },
                    {
                        title: 'UPD por Tipo y Usuario',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteUPDUsuario', // Corregido
                        activo: 'importación/reportes_importación/captura_upd/upd_por_tipo_y_usuario',
                        permiso: [38],
                    },
                    {
                        title: 'UPD Totales por usuario',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteUPDTotalUsuario', // Corregido
                        activo: 'importación/reportes_importación/captura_upd/upd_totales_por_usuario',
                        permiso: [39],
                    },
                ],
            },
            {
                title: 'Cajas',
                icono: 'Dashboard.svg',
                enlace: '#',
                activo: 'importación/reportes_importación/cajas',
                permiso: [40, 41, 42],
                hijos: [
                    {
                        title: 'Kardex',
                        icono: 'Dashboard.svg',
                        enlace: '#', // Corregido
                        activo: 'importación/reportes_importación/cajas/kardex',
                        permiso: [40],
                    },
                    {
                        title: 'General',
                        icono: 'Dashboard.svg',
                        enlace: '#', // Corregido
                        activo: 'importación/reportes_importación/cajas/general',
                        permiso: [41],
                    },
                    {
                        title: 'Tómbola',
                        icono: 'Dashboard.svg',
                        enlace: '#', // Corregido
                        activo: 'importación/reportes_importación/cajas/tombola',
                        permiso: [42],
                    },
                ],
            },
            {
                title: 'Facturación',
                icono: 'Dashboard.svg',
                enlace: '#',
                activo: 'importación/reportes_importación/facturación',
                permiso: [43, 44, 45],
                hijos: [
                    {
                        title: 'Productividad Facturación por Usuario',
                        icono: 'Dashboard.svg',
                        enlace: 'ProductividadFacturacionUsuario', // Corregido
                        activo: 'importación/reportes_importación/facturación/productividad_facturación_por_usuario',
                        permiso: [43],
                    },
                    {
                        title: 'Facturas canceladas por Usuario',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteFacturasCanceladasUsuario', // Corregido
                        activo: 'importación/reportes_importación/facturación/facturas_canceladas_por_usuario',
                        permiso: [44],
                    },
                    {
                        title: 'Facturas por horas al día',
                        icono: 'Dashboard.svg',
                        enlace: 'FacturasHoraDia', // Corregido
                        activo: 'importación/reportes_importación/facturación/facturas_por_horas_al_día',
                        permiso: [45],
                    },
                ],
            },
            {
                title: 'Tiempos de atención en Previos',
                icono: 'Dashboard.svg',
                enlace: 'ReporteTiemposPrevios', // Corregido
                activo: 'importación/reportes_importación/tiempos_de_atención_en_previos',
                permiso: [46],
            },
            {
                title: 'Salidas',
                icono: 'Dashboard.svg',
                enlace: '#',
                activo: 'importación/reportes_importación/salidas',
                permiso: [47, 48],
                hijos: [
                    {
                        title: 'Salidas Importación',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteSalidasImportacion', // Corregido
                        activo: 'importación/reportes_importación/salidas/salidas_importación',
                        permiso: [47],
                    },
                    {
                        title: 'Tiempos de atención de Salidas',
                        icono: 'Dashboard.svg',
                        enlace: 'ReporteTiemposSalidaImpo', // Corregido
                        activo: 'importación/reportes_importación/salidas/tiempos_de_atención_de_salidas',
                        permiso: [48],
                    },
                ],
            },
            {
                title: 'Anual',
                icono: 'Dashboard.svg',
                enlace: '#', // Corregido
                activo: 'importación/reportes_importación/anual',
                permiso: [49],
            },
        ],
    },
];

export const getGestionDeAlmacenMenu = () =>
    getFilteredMenu(gestionDeAlmacenMenu);

const MenuItem = ({ item, activePath, onSetActive, onHoverChange, hoveredItem, onComponentChange }) => {
    
    const [isOpen, setIsOpen] = useState(false); 
    const hasChildren = item.hijos && item.hijos.length > 0;
    
    // Defensa: Asegura que activePath sea un string para evitar el error "undefined.startsWith"
    const currentPath = activePath || ''; 
    
    // Lógica para determinar el resaltado
    const isCurrentActive = item.activo === currentPath;
    const isAncestorActive = currentPath.startsWith(item.activo + '/') && !isCurrentActive;

    // Colapso automático/apertura si es parte del path activo
    useEffect(() => {
        if (isAncestorActive || isCurrentActive) {
            setIsOpen(true);
        }
    }, [isAncestorActive, isCurrentActive]);
    
    // Lógica de Hover (se mantiene)
    const isHighlighted = (item.title === hoveredItem); 
    const hoverProps = hasChildren ? {
        onMouseEnter: () => onHoverChange(item.title),
        onMouseLeave: () => onHoverChange(null),
    } : {};


    // FUNCIÓN CLAVE: Manejo de Clic y Notificación con Doble Argumento
    const handleItemClick = (e) => {
        
        // 1. Lógica de Colapso (Si tiene hijos)
        if (hasChildren) {
            e.preventDefault(); 
            setIsOpen(!isOpen);
        } 
        
        // 2. Lógica de Navegación/Selección (Elementos hoja)
        else {
            e.preventDefault();
            
            if (onComponentChange) {
                sessionStorage.setItem('currentModule', item.enlace !== '#' ? item.enlace : '');
                // Notifica a Admin.js: Envía el Nombre del Componente y la Ruta Activa
                onComponentChange(item.enlace, item.activo); 
            }
            
            // onSetActive ya no se llama localmente porque Admin.js lo maneja.
        }
    };

    // Determina las clases de estilo (se mantiene)
    let itemClass = '';
    if (isCurrentActive) {
        itemClass = 'is-active'; 
    } else if (isAncestorActive) {
        itemClass = 'is-ancestor';
    }


    return (
        <li 
            className={`menu-item ${item.activo} ${itemClass} ${isHighlighted ? 'highlighted' : ''}`}
            {...hoverProps} 
        >
            <a 
                href={item.enlace} 
                onClick={handleItemClick}
                className={`
                    menu-link 
                    text-white 
                    px-3 d-flex 
                    justify-content-between 
                    align-items-center
                    ${item.enlace === sessionStorage.getItem("currentModule") ? 'active' : ''}
                `}
            >
                {item.title}
                {hasChildren && <span className="arrow">{isOpen ? '▲' : '▼'}</span>} 
            </a>
            
            {/* Llamada Recursiva: Pasamos todos los props necesarios */}
            {hasChildren && (
                <ul className="submenu" style={{ display: isOpen ? 'block' : 'none' }}>
                    {item.hijos.map((child, index) => (
                        <MenuItem 
                            key={index} 
                            item={child} 
                            activePath={activePath} 
                            onSetActive={onSetActive} // Dummy
                            onHoverChange={onHoverChange}
                            hoveredItem={hoveredItem}
                            onComponentChange={onComponentChange} // <-- ¡Pasado recursivamente!
                        />
                    ))}
                </ul>
            )}
        </li>
    );
};

const MenuGestion = ({ activePath, onComponentChange }) => { 
    
    // Estados locales (solo Hover)
    const [hoveredItem, setHoveredItem] = useState(null);
    const menuItems = getGestionDeAlmacenMenu();
    const handleHoverChange = (title) => { setHoveredItem(title); };
    
    // Función dummy para onSetActive (ya no gestiona el estado, solo cumple la firma)
    const handleSetActiveDummy = () => {}; 
    
    return (
        <nav className="menu-importacion">
            <ul className="menu-list">
                {menuItems.map((item, index) => (
                    <MenuItem 
                        key={item.title || index} 
                        item={item} 
                        activePath={activePath} // <-- Recibido de Admin.js
                        onSetActive={handleSetActiveDummy} 
                        onHoverChange={handleHoverChange} 
                        hoveredItem={hoveredItem}
                        onComponentChange={onComponentChange} // <-- Función enviada al fondo
                    /> 
                ))}
            </ul>
        </nav>
    );
};



export default MenuGestion;
